// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle__3n6ML","sectionTitle2":"SectionTitle_sectionTitle2__4vYlH"};